import * as React from 'react';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { DamsAppAsset } from '../../assets/registry';
import { IconButton } from '@mui/material';
import { DamsColors } from '../styles/DamsColors';

interface LabelButtonProps {
    direction?: 'right' | 'left' | string;
    label?: string;
    onPress?: () => void
}

const StyledTypography = styled(Typography)(({ theme }) => ({
    fontFamily: 'inherit',
    fontSize: 14,
    fontWeight: 600,
}));

const LabelButton = ({ direction = 'right', label = 'Label info' , onPress}: LabelButtonProps) => {
    const textColor = direction === 'left' ? DamsColors.Authentication.labelText : DamsColors.Authentication.Button

    const handleOnClick: React.MouseEventHandler<HTMLButtonElement> = (event) => {
        if (onPress !== undefined) {
            onPress();
        }
    }
    return (
        <IconButton
            disableRipple
            disableFocusRipple
            onClick={handleOnClick}
            sx={styles.labelContainer}>
            {direction === 'left' && (
                <>
                    <img src={DamsAppAsset.icons.dark_back_arrow} alt='Label Icon' style={styles.iconImg} />
                    <StyledTypography color={textColor} ml={1} >{label}</StyledTypography>
                </>
            )}

            {direction === 'right' && (
                <>
                    <StyledTypography color={textColor} mr={1} >{label}</StyledTypography>
                    <img src={DamsAppAsset.icons.green_forward_arrow} alt='Label Icon' style={styles.iconImg} />
                </>
            )}

        </IconButton>
    );
};

const styles = {
    labelContainer: {
        // border: '1px solid green',
        padding: 0

    },
    iconImg: {
        width: 15,
        height: 13
    }
}

export default LabelButton;
